// extracted by mini-css-extract-plugin
export default {"content":"content--XCsSv","blink":"blink--KqNo7"};